module.exports = __webpack_public_path__ + "img/icon-letter-f.fa4e8508.svg";